import { isAuditorTeamTypes } from "utils";
import type { VitalsColumnTakenBy } from "../types/types";

/**
 * EN-3703: records created by auditor users must render as if no user
 * made the change. Returns null when the takenBy user belongs to an
 * auditor team, so callers render an empty cell.
 */
export function getVisibleTakenBy(
  takenBy?: VitalsColumnTakenBy | null
): VitalsColumnTakenBy | null {
  if (!takenBy) return null;
  if (isAuditorTeamTypes(takenBy.teamTypes)) return null;
  return takenBy;
}
